import React from 'react';

export default function EmptyState({ icon: Icon, title, description, action, 'data-testid': testId }) {
  return (
    <div
      data-testid={testId}
      className="rounded-lg border border-dashed border-border bg-white px-6 py-14 text-center"
    >
      {Icon && (
        <div className="mx-auto h-12 w-12 rounded-full bg-warmgrey-soft text-warmgrey flex items-center justify-center">
          <Icon size={22} strokeWidth={1.75} />
        </div>
      )}
      <h3 className="mt-4 font-display font-semibold text-lg text-charcoal">{title}</h3>
      {description && (
        <p className="mt-1 text-sm text-muted-foreground max-w-md mx-auto">{description}</p>
      )}
      {action && <div className="mt-5 flex justify-center">{action}</div>}
    </div>
  );
}
